import { lazy, ReactNode } from "react";
import styles from "./Layout.module.scss";
import clsx from "clsx";

// import { isMobile } from "react-device-detect";
import MobileDetected from "../../features/mobile-view";
import { useAppSelector } from "../../store/store";
import { selectSidebarState } from "../Sidebar/redux/sidebarSlice";
import GgLogo from "../icons/GgLogo";

const Header = lazy(() => import("../Header/Header"));
const Sidebar = lazy(() => import("../Sidebar/Sidebar"));
function Layout({
  children,
  noDisplay,
  isScrollInside,
  isFallback = false,
  contentClassName,
  mainClassName,
  fixedHeader,
}: {
  children: ReactNode;
  noDisplay?: Boolean;
  isScrollInside?: Boolean;
  isFallback?: Boolean;
  contentClassName?: string;
  mainClassName?: string;
  fixedHeader?: Boolean;
}) {
  const { isOpen } = useAppSelector(selectSidebarState);
  const isMobile = false;
  return (
    <div className={`${styles.wrapper}`}>
      <div className={styles.headerContainer}>
        <div className={styles.logo}>
          <GgLogo height={36} width={140}/>
        </div>
        <header className={styles.header}>
          <Header />
        </header>
      </div>
      {isMobile ? (
        <MobileDetected />
      ) : (
        <>
          <div className={clsx(styles.sidebar, !isOpen && styles.closeSidebar)}>
            <Sidebar isFallback={isFallback} />
          </div>
          <div
            style={{ display: `${noDisplay ? "block" : "flex"}` }}
            className={clsx(
              styles.content,
              isScrollInside && styles.overflowHidden,
              !isOpen && styles.contentCloseSidebar,
              contentClassName
            )}
          >
            <main
              id="body"
              className={clsx(
                styles.main,
                mainClassName,
                fixedHeader && styles.fixedHeight
              )}
            >
              {children}
            </main>
          </div>
        </>
      )}
    </div>
  );
}

export default Layout;
